import { RecommendedVehicle } from '~/contracts/vdp';
import getMonthAndDay from '~/utilities/date/getMonthAndDay';
import getWeekDay from '~/utilities/date/getWeekDay';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import {
  ArrivalBanner,
  Card,
  CardMaxWidth,
  Dot,
  ImageHeight,
  Img,
  InnerTextWrapper,
  TextBox
} from './DeliveryStyles.styles';
import useVehicleAnalyticsAttributes from '../hooks/useVehicleAnalyticsAttributes';

type OwnProps = {
  vehicle: Partial<RecommendedVehicle>;
};

const DeliveryCard = ({ vehicle }: OwnProps) => {
  const vehicleAnalyticsAttributes = useVehicleAnalyticsAttributes(vehicle);
  const {
    earliestAvailabilityDate,
    earliestDaysToAvailability = 0,
    imageUrl,
    make,
    mileage = 0,
    model,
    price: { total = 0 } = {},
    trim,
    vehicleId,
    year,
    transportCost
  } = vehicle;

  let getItDate = '';

  if (earliestAvailabilityDate) {
    getItDate =
      earliestDaysToAvailability < 7
        ? getWeekDay(earliestAvailabilityDate)
        : getMonthAndDay(earliestAvailabilityDate);
  }

  const formattedCost = transportCost
    ? `$${formatAndDropDecimal(transportCost)}`
    : 'Free';

  return (
    <a
      data-analytics-id="Earliest Delivery - Vehicle Card"
      data-analytics-attributes={vehicleAnalyticsAttributes}
      data-native-link="self"
      data-native-payload={JSON.stringify({ vehicleId })}
      href={`/vehicle/${vehicleId}`}
      draggable={false}
    >
      <Card>
        <Img
          height={ImageHeight}
          width={CardMaxWidth}
          src={imageUrl}
          alt="vehicle image"
        />
        {getItDate && <ArrivalBanner>Arrives {getItDate}</ArrivalBanner>}
        <TextBox>
          <p className="mb-4 tl-header-m">
            {year} {make} {model}
          </p>
          <p className="mb-12 content-center tl-body-s">
            {trim} <Dot /> {mileage.toLocaleString()} miles
          </p>
          <InnerTextWrapper>
            <p className="tl-header-xl">${formatAndDropDecimal(total)}</p>
            <p className="tl-header-xs">{formattedCost} Shipping</p>
          </InnerTextWrapper>
        </TextBox>
      </Card>
    </a>
  );
};

export default DeliveryCard;
